export const LOCATION_LIMIT = 10000;

export const BULK_CIRCLES_SPLITER = /\n|;/;

export const MIN_RADIUS = 0.001;
export const MAX_RADIUS = 10;

export const MIN_LATITUDE = -90;
export const MAX_LATITUDE = 90;
export const LATITUDE_DECIMALS = 6;

export const MIN_LONGITUDE = -180;
export const MAX_LONGITUDE = 180;
export const LONGITUDE_DECIMALS = 6;
